import {
    COMMUNITY_ITEM_RESPONSE,
    KNOWLEDGE_ITEM_RESPONSE,
    STUDIO_ITEM_RESPONSE,
    DIMENSION_ITEM_RESPONSE,
    DIMENSION_ITEM_SAVE_RESPONSE,
    DIMENSION_LIST_RESPONSE,
    STUDIO_EDIT_ADD_KEY_ISSUES_RESPONSE,
    TOPIC_ITEM_RESPONSE,
    UNAUTHENTICATED,
    STUDIO_ITEM_SAVE_RESPONSE,
    TOPIC_ITEM_SAVE_RESPONSE
} from "../../actions/action-types"
import { extractEntitiesFromData } from "./entity-reducer-utils"
import { normalise } from "../../models/entities/dimension"

export default (state = {}, action) => {
    const { type, data, receivedAt } = action
    switch (type) {
        case STUDIO_ITEM_SAVE_RESPONSE:
        case STUDIO_ITEM_RESPONSE:
            return extractEntitiesFromData(
                data.dimensions,
                state,
                false,
                normalise
            )
        case COMMUNITY_ITEM_RESPONSE:
        case KNOWLEDGE_ITEM_RESPONSE:
        case TOPIC_ITEM_SAVE_RESPONSE:
        case TOPIC_ITEM_RESPONSE:
            return data ? extractEntitiesFromData(data.dimensions, state) : state;
        case STUDIO_EDIT_ADD_KEY_ISSUES_RESPONSE:
            return action.dimensionActions.reduce(
                (state, { data, receivedAt }) => {
                    return {
                        ...state,
                        [data.id]: {
                            ...state[data.id],
                            ...normalise(data),
                            lastUpdatedAt: receivedAt
                        }
                    }
                },
                state
            )
        case DIMENSION_LIST_RESPONSE:
            return extractEntitiesFromData(data, state)
        case DIMENSION_ITEM_SAVE_RESPONSE:
        case DIMENSION_ITEM_RESPONSE:
            return {
                ...state,
                [data.id]: {
                    ...state[data.id],
                    ...normalise(data),
                    lastUpdatedAt: receivedAt
                }
            }
        case UNAUTHENTICATED:
            return {}
        default:
            return state
    }
}
